<template>
	<v-container id="hopper_carousel" class="raporto-wrapper">
		<div class="parent-title-wrapper">{{getStateWithParam(currentMenuParent.name)}}</div>
		<section class="hooper hooper-navigation">
			<InnerMenuCarousel :menuItemToPresent="item" />
		</section>
		<router-view></router-view>
	</v-container>
</template>

<script>
import InnerMenuCarousel from "./InnerMenuCarousel";
import "hooper/dist/hooper.css";
export default {
	name: 'ViewHeader',
	components: {
		InnerMenuCarousel,
	},
	computed: {
		currentMenuParent(){
			return this.$route.matched[0]
		},
		item(){
			const matched = this.$route.matched;
			let parentRoute = this.$router.options.routes.find((routeitem) => routeitem.name == matched[0].name)
			let currentRoute = parentRoute.children ? parentRoute.children[0] : parentRoute
			return currentRoute
		}
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	}
}
</script>

<style scoped lang="scss" src="./ItemMenuSlider.scss">
</style>